import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import axios from 'axios'
import { API_URL } from '@/constants/constant'
import type { Coupon, TransformedCoupon } from '@/interface/Coupon'
import type { AxiosError } from 'axios'

import { useSettingsStore } from '@/stores/settings'

export const useCounterStore = defineStore('counter', () => {
  const count = ref(0)
  const doubleCount = computed(() => count.value * 2)
  const coupons = ref<TransformedCoupon[]>([])

  const settingsStore = useSettingsStore()

  function increment() {
    count.value++
  }

  async function fetchCoupons() {
    const settingsStore = useSettingsStore()

    try {
      const path = 'admin/coupons'
      const response = await axios.get(`${API_URL}/${path}`, {
        headers: {
          'Content-Type': 'application/json',
        },
        params: {
          accountId: settingsStore.accountId,
        },
      })
      console.log('response / data', response.data)
      const data = response?.data

      coupons.value = await Promise.all(
        data
          .filter((item: Coupon | undefined) => item?.placements && item.placements.includes(settingsStore.placementId))
          .map(async (coupon: Coupon, index: number) => {
            return {
              index: index + 1,
              code: coupon.couponId,
              description: coupon.design?.description,
              disclaimer: coupon.design?.disclaimer,
              couponImage: coupon?.design?.media?.couponImage,
              logo: coupon?.design?.media?.logo,
              thumbnail: coupon?.design?.media?.thumbnail,
              listItems: coupon.design?.listItems,
              title: coupon.design?.title,
              startTime: coupon.startTime,
              endTime: coupon.endTime,
              status: coupon.status,
              fontColor: coupon.typography?.title?.fontColor,
              fontSize: coupon.typography?.title?.fontSize,
              fontWeight: coupon.typography?.title?.fontWeight,
              lineHeight: coupon.typography?.title?.lineHeight,
              textAlign: coupon.typography?.title?.textAlign,
              textTransform: coupon.typography?.title?.textTransform,
              textDecoration: coupon.typography?.title?.textDecoration,
              // for description
              descriptionfontColor:
                coupon.typography?.title?.descriptionfontColor,
              descriptionfontSize:
                coupon.typography?.title?.descriptionfontSize,
              descriptionfontWeight:
                coupon.typography?.title?.descriptionfontWeight,
              descriptionlineHeight:
                coupon.typography?.title?.descriptionlineHeight,
              descriptiontextAlign:
                coupon.typography?.title?.descriptiontextAlign,
              descriptiontextTransform:
                coupon.typography?.title?.descriptiontextTransform,
              descriptiontextDecoration:
                coupon.typography?.title?.descriptiontextDecoration,

              // for disclaimer

              disclaimerfontColor:
                coupon.typography?.title?.disclaimerfontColor,
              disclaimerfontSize: coupon.typography?.title?.disclaimerfontSize,
              disclaimerfontWeight:
                coupon.typography?.title?.disclaimerfontWeight,
              disclaimerlineHeight:
                coupon.typography?.title?.disclaimerlineHeight,
              disclaimertextAlign:
                coupon.typography?.title?.disclaimertextAlign,
              disclaimertextTransform:
                coupon.typography?.title?.disclaimertextTransform,
              disclaimertextDecoration:
                coupon.typography?.title?.disclaimertextDecoration,
              height: coupon.typography?.title?.height,
              isPaused: coupon.isPaused,
              placements: coupon.placements || [],
            }
          }),
      )

      return data
    } catch (err) {
      const error = err as AxiosError
      console.log('Error fetching coupons:', error?.response?.data)
      // Simplified error handling without user store dependency
      localStorage.clear()
    }
  }



  return {
    count,
    doubleCount,
    increment,
    coupons,
    fetchCoupons,
  }
})
